import classnames from 'classnames2';
import React from 'react';
import styles from './CheckboxIcon.scss';

var Background = function Background(props) {
  return React.createElement("rect", {
    fill: props.fill,
    className: props.className,
    width: "24",
    height: "24",
    rx: "3",
    ry: "3"
  });
};

var Outline = function Outline(props) {
  return React.createElement("path", {
    fill: props.fill,
    className: props.className,
    d: "M21,2a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H21m0-2H3A3,\n       3,0,0,0,0,3V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3Z"
  });
};

var CheckMark = function CheckMark(props) {
  return React.createElement("polygon", {
    fill: props.fill,
    className: props.className,
    points: "17.66 5.64 9.17 14.12 6.34 11.29 4.22 13.41 7.05 16.24 9.17 18.36\n             11.29 16.24 19.78 7.76 17.66 5.64"
  });
};

export var CheckboxIcon = function CheckboxIcon(props) {
  if (props.color) {
    return React.createElement("svg", {
      width: 24,
      height: 24,
      className: classnames(props.className, props.checked && styles.checked)
    }, React.createElement(Background, {
      className: styles.indicatorBackgroundNoColor,
      fill: props.color
    }), React.createElement(Background, {
      className: styles.indicatorBackgroundHide,
      fill: "white"
    }), React.createElement(Outline, {
      className: styles.indicatorOutlineNoColor,
      fill: props.color
    }), React.createElement(CheckMark, {
      className: styles.indicatorCheckMark
    }));
  } else {
    return React.createElement("svg", {
      width: 24,
      height: 24,
      className: classnames(props.className, props.checked && styles.checked)
    }, React.createElement(Background, {
      className: styles.indicatorBackground
    }), React.createElement(Outline, {
      className: styles.indicatorOutline
    }), React.createElement(CheckMark, {
      className: styles.indicatorCheckMark
    }));
  }
};